import { Component, OnInit } from '@angular/core';
import { Router, RouterEvent } from '@angular/router';
import { filter } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AuthService } from './_core/services/auth.service';
import config from "devextreme/core/config";
import { licenseKey } from '../devextreme-license';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent  implements OnInit {
  title = 'spa';

  isAuth: any;

  constructor(
    private router: Router,
    private authService: AuthService,
  ) {
    //this.checkLogin();
  }

  ngOnInit() {

    const isAuth = this.authService.isAuthenticated;

    config({ licenseKey });

    this.router.events
    .pipe(
      filter((e: any): e is RouterEvent => e instanceof RouterEvent)
    ).subscribe((e: RouterEvent) => {
      if (e.url.includes('auth-return')) {
        return;
      }
      this.authService.attemptedUrl = e.url;
    });

  }

  // isAuthorized() {
  //   return this.authService.isAuthenticated;
  // }

  // private async checkLogin() {
  // //console.log('app.config checkLogin');
  // //const si = this.authService.checkSignedIn();
  // //const signin = await this.authService.signInSilent(null);
  //   const check = await this.authService.checkSignedIn().then(value => {
  //     return;
  //   });

  // }



}


